import { useState } from "react";
import { useTranslation } from "react-i18next";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { TimePicker, TimePickerProps } from "@mui/x-date-pickers/TimePicker";
import { Locale } from "date-fns";
import { arSA, enUS } from "date-fns/locale";

const localeMap: Record<string, Locale> = {
  ar: arSA,
  "ar-SA": arSA,
  en: enUS,
  "en-US": enUS,
};
const defaultLocale = enUS;

const TimeField = ({
  disabled,
  value,
  handleOnChange,
  helperText,
  hasError,
  ...props
}: {
  disabled: boolean;
  value: any;
  handleOnChange: (value: any) => void;
  helperText: string;
  hasError: boolean;
  placeholder?: string;
} & Omit<TimePickerProps<any>, "onChange" | "value">) => {
  const { i18n } = useTranslation();
  const [open, setOpen] = useState(false);
  const locale = localeMap[i18n.language] ?? defaultLocale;

  return (
    <LocalizationProvider dateAdapter={AdapterDateFns} adapterLocale={locale}>
      <TimePicker
        disabled={disabled}
        value={value}
        onChange={handleOnChange}
        open={open}
        onOpen={() => setOpen(true)}
        onClose={() => setOpen(false)}
        slotProps={{
          textField: {
            error: hasError,
            helperText,
            size: "small",
            onFocus: () => setOpen(true),
            onBlur: () => setOpen(false),
            onClick: (e) => {
              e.stopPropagation();
              setOpen(true);
            },
          },
        }}
        {...props}
      />
    </LocalizationProvider>
  );
};

export default TimeField;
